import {
  selectChipRequestAction,
  selectChipSuccessAction,
  selectChipFailureAction,
  selectChipSetAction,
  gameActions as gameActionsFromSlice,
} from '../reducers/game';

export const gameActions = {
  game: gameActionsFromSlice,
  selectChip: {
    request: selectChipRequestAction,
    success: selectChipSuccessAction,
    failure: selectChipFailureAction,
    set: selectChipSetAction,
  },
};
